import { render } from "./recordListTeacher.vue?vue&type=template&id=18211675&scoped=true"
import script from "./recordListTeacher.vue?vue&type=script&lang=js"
export * from "./recordListTeacher.vue?vue&type=script&lang=js"

import "./recordListTeacher.vue?vue&type=style&index=0&id=18211675&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18211675"]])

export default __exports__